import { useMemo } from 'react'

import { CurrencyCodeFlagIcon } from '@pages/IntroducingBroker/Dashboard/components/CurrencyCodeFlagIcon/CurrencyCodeFlagIcon'

import { IconFCType } from '@ui/icons/types'
import { createValidIcon } from '@ui/icons/utils/type-helper'

import type { WalletDto } from '@model/WalletDto'

export const useWalletCurrencyIcons = (wallets: WalletDto[]) => {
  return useMemo(() => {
    const icons: Record<string, IconFCType> = {}

    for (const w of wallets) {
      const ccy = w.currency?.id
      if (!ccy || icons[ccy]) continue
      icons[ccy] = createValidIcon(({ size = 16 }) => (
        <CurrencyCodeFlagIcon currencyType={ccy} size={size} />
      ))
    }

    return icons
  }, [wallets])
}
